import React, { useState, useEffect } from 'react';
import { createGroup, getClasses, fetchStreams } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const CreateGroupModal = ({ onClose, onGroupCreated }) => {
    const [classes, setClasses] = useState([]);
    const [streams, setStreams] = useState([]);
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedStream, setSelectedStream] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const classesData = await getClasses();
                setClasses(classesData.data);
                const streamsData = await fetchStreams();
                setStreams(streamsData.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        try {
            await createGroup({ class_id: parseInt(selectedClass), stream_id: parseInt(selectedStream) });
            setSuccess('Group created successfully!');
            onGroupCreated();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Group</h2>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)} required>
                            <option value="">Select Class</option>
                            {classes.map(cls => (
                                <option key={cls.id} value={cls.id}>{`${cls.term.name} - ${cls.level.name}`}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <select value={selectedStream} onChange={(e) => setSelectedStream(e.target.value)} required>
                            <option value="">Select Stream</option>
                            {streams.map(stream => (
                                <option key={stream.id} value={stream.id}>{stream.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="actions-centered">
                        <button type="button" className="cancel-button text-button" onClick={onClose}>Cancel</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateGroupModal;